import { customizationEntries } from '../webchatEditor/constants/customizationEntries'
import { voiceCustomizationEntries, VoiceCustomizationEntry } from '../webchatEditor/constants/voiceCustomizationEntries'
import { Category, SubCategory, UISelectorType, VoiceCategory, EditorMode } from "../utilities/types"
import { ContainerName } from "./reducers/AppReducer";
import * as merge from 'deepmerge';
import { isPlainObject } from 'is-plain-object';

declare const DruidWebchat_v2: any;


export interface BaseCustomizationEntry {
    id: string,
    displayName: string,
    uiSelectorType: UISelectorType // TODO create uiSelectorType interface
    isAdvancedOption?: boolean,
    containerName?: ContainerName,
    multiline?: boolean,
    defaultValue?: any,
    hidden?: boolean | string[],
    disabled?: boolean | string[]
}

export interface CustomizationEntry extends BaseCustomizationEntry {
    category: Category,
    subCategory?: SubCategory,
}

export interface IAppState {
    // Active category to be rendered in middle pane
    activeCategory: Category,
    // Value of UI elements that determine style option value stored here
    customizationEntries: CustomizationEntry[],
    editorMode: EditorMode,
    activeVoiceCategory: VoiceCategory,
    voiceCustomizationEntries: VoiceCustomizationEntry[],
    // Value of current style options stored here
    webchatOptions: WebchatOptions;
    jsonIsInvalid: boolean;
    // Closes Modal for color switch when user selects other color selectors. This will fixes having a modal open for each colorSelector
    displayColorModal: boolean;
    colorValue: string;
    initialized: boolean;
    selectedThemeId?: string;
    navigationTarget?: NavigationTarget;
}

export interface NavigationTarget {
    category: string;
    subCategory?: string;
    entryId?: string;
}

export interface VoiceSipOptions {
    isEnabled: boolean;
    bridgeUrl: string;
    botHash: string;
}

// TODO: Figure out way to get strongly types style Options obj that maps to https://github.com/microsoft/BotFramework-WebChat/blob/master/packages/component/src/Styles/defaultStyleOptions.js
export interface WebchatOptions {
    styleOptions: any,
    UI: any,
    VoiceUI?: any,
    middlewares: any,
    localization: any,
    languages: any
    customDruidStyleSet: any,
    webChatEventHandler?: any,
    webChatEventHandlerString?: string,
    voiceSettings: VoiceSipOptions;
  }

  export const loadConfigurationValue =
 {
//   "isDisabled": false,
//   "accessibilityFeaturesEnabled": false,
//   "backgroundTrafficEnabled": true,
//   "conversationTokenEnabled": true,
//   "cookieDomain": "",
//   "druidCookiesExpirationInDays": 1,
//   "druidWebChatIsOpenedEnabled": true,
//   "druidShowGroupTimestamp": 10000,
//   "extendedLocalizedString": {
//     "timeSent": " - %1",
//     "suggestedActionsInputPlaceholder": ""
//   },
//   "instrumentationKey": "",
//   "notificationsEnabled": false,
//   "queryParams": "",
//   "serviceNetworkStatusEnabled": true,
//   "UI": {
//     "autoExpandEnabled": false,
//     "autoScrollEnabled": false,
//     "chatHeaderHeight": "38px",
//     "chatTitle": " Mihai-test-bot",
//     "chatTitle_faIcon": "",
//     "containerElement": null,
//     "contextMenuIcon": "fa-plus-circle",
//     "druidLayoutVersionDecorator": "druid-v2",
//     "expandWidth": "unset",
//     "floatRight": "10%",
//     "failedToLoadMessage": "Failed to load",
//     "fullScreenMode": false,
//     "fullScreenMode_leftRightClass": "col-md-3",
//     "fullScreenMode_mainChatClass": "col-md-6",
//     "goBackButton": false,
//     "height": "90vh",
//     "iconCloseChat": "fa-angle-down",
//     "iconSendSvgType": 2,
//     "inputIconsAlignment": "left",
//     "inputPlaceholder": "Type your message here...",
//     "loadingOverlayActive": true,
//     "minWidth": "25vw",
//     "position": "right",
//     "typingMessageBackground": null,
//     "visibleAtScrollTop": false,
//     "width": "430px",
//     "headerOptions": {
//       "showAvatar": true
//     }
//   },
//   "disabled": false,
//   "styleOptions": {
//     "accent": "olive"
//   },
//   "webChatEventHandler": "(action, currentDruidState) => {if (action.type === 'DIRECT_LINE/INCOMING_ACTIVITY' && DruidWebchat_v2.isNewActivity(currentDruidState, action.payload.activity)) {if(action.payload.activity.text == \"disable\") {console.error('gigel')}}}",
//   "middlewares": {},
//   "languages": [
//     {
//       "displayName": "Arabic",
//       "nativeName": "العربية",
//       "name": "ar",
//       "isDefault": false,
//       "icon": "famfamfam-flags sa",
//       "id": 2
//     },
//     {
//       "displayName": "Croatian",
//       "nativeName": "hrvatski",
//       "name": "hr",
//       "isDefault": false,
//       "icon": "famfamfam-flags hr",
//       "id": 24
//     },
//     {
//       "displayName": "Danish",
//       "nativeName": "dansk",
//       "name": "da",
//       "isDefault": false,
//       "icon": "famfamfam-flags dk",
//       "id": 26
//     },
//     {
//       "displayName": "English (United States)",
//       "nativeName": "English (United States)",
//       "name": "en-US",
//       "isDefault": false,
//       "icon": "famfamfam-flags us",
//       "id": 1
//     },
//     {
//       "displayName": "Portuguese",
//       "nativeName": "português",
//       "name": "pt",
//       "isDefault": false,
//       "icon": "famfamfam-flags pt",
//       "id": 20
//     },
//     {
//       "displayName": "Romanian",
//       "nativeName": "română",
//       "name": "ro",
//       "isDefault": true,
//       "icon": "famfamfam-flags ro",
//       "id": 15
//     }
//   ]
}

export const defaultWebchatOptions = (mergeWith: Partial<WebchatOptions> = {}) => merge.all<WebchatOptions>([DruidWebchat_v2.webChatDefaultOptions, loadConfigurationValue, mergeWith], { isMergeableObject: isPlainObject });

export const initialAppState: IAppState = {
    activeCategory: Category.General,
    customizationEntries: customizationEntries,
    editorMode: EditorMode.Webchat,
    activeVoiceCategory: VoiceCategory.General,
    voiceCustomizationEntries: voiceCustomizationEntries,
    // webchatOptions: {
    //     styleOptions: {
    //         ...defaultStyleOptions, 
    //         ...DruidWebchat_v2.overridenBFStyleOptions
    //     },
    //     UI: DruidWebchat_v2.getMe
    // },
    webchatOptions: defaultWebchatOptions(),
    jsonIsInvalid: false,
    displayColorModal: false,
    colorValue: '#ffffff',
    initialized: false
}
